import { responseHero } from "../utils/axiosInterceptor";

export type BuyingParamsResponse = {
    avgBitcoinPurchasePrice: string,
    avgEthereumPurchasePrice: string,
    totalFreeLiquidity: string,
    nextAdvisedLiquidity: string
}

export const getBMPBuyingDetails = (groupId: number): Promise<BuyingParamsResponse> => {
    return new Promise<BuyingParamsResponse>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/buying/${groupId}`).then((response) => {
            resolve(response.data as BuyingParamsResponse);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};